export interface SunBurstProps {
  size?: number;
  className?: string;
}

/**
 * Sol radiante de rayos alternos — el motivo que abre el manifiesto y cierra la
 * banda de entradas en `DEMO_4_Mexico.png`.
 *
 * Es SVG propio y no imagen (ADR-004 §1.3). Vive en la pagina y no en el
 * substrato porque FORGE-ALPHA aun no publica `sunburst` (PAGE_CONTRACT §10);
 * peticion cursada. El dia que lo publique, se sustituye el import y se borra.
 */
export function SunBurst({ size = 30, className }: SunBurstProps) {
  const rays = Array.from({ length: 16 }, (_, i) => {
    const angle = (i * Math.PI) / 8;
    const inner = 6.6;
    const outer = i % 2 === 0 ? 11.4 : 9.2;
    return {
      x1: 12 + inner * Math.cos(angle),
      y1: 12 + inner * Math.sin(angle),
      x2: 12 + outer * Math.cos(angle),
      y2: 12 + outer * Math.sin(angle),
    };
  });

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={0.85}
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="2.5" />
      <circle cx="12" cy="12" r="5" opacity="0.75" />
      {rays.map((ray, i) => (
        <line key={i} x1={ray.x1} y1={ray.y1} x2={ray.x2} y2={ray.y2} />
      ))}
    </svg>
  );
}
